import React from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { wa } from "@/lib/brand";

const EnquiryConfirmation = () => {
  const { id } = useParams();
  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-testid="enquiry-confirmation">
      <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#F7F2E2] border border-[#D4AF37]/50">
        <CheckCircle2 className="h-7 w-7 text-[#004225]" />
      </div>
      <h1 className="mt-6 font-display text-3xl sm:text-4xl text-[#004225]">Thank you. Your enquiry has been received.</h1>
      <p className="mt-3 text-[14px] text-[#171717]/75">Our team will review your requirements and contact you shortly.</p>
      {id && <p className="mt-3 text-[12px] text-[#171717]/60">Reference: <span className="font-mono">{id}</span></p>}
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link to="/products" className="rounded-full btn-primary px-6 py-3 text-[11px] font-semibold uppercase tracking-widest">Continue Browsing</Link>
        <a href={wa()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-6 py-3 text-[11px] font-semibold uppercase tracking-widest"><MessageCircle className="h-4 w-4" />WhatsApp Us</a>
      </div>
    </section>
  );
};

export default EnquiryConfirmation;
